/* eslint-disable no-param-reassign */
import { getBuildNumber } from 'shared/utils/executionEnvironment';
import BillingType from '../../../../shared/domain/billing/model/BillingType';

const optimizeDocumentBeforeSave = async ({ document }) => {
  removePoolNumberIfBillingTypeIsPriv(document);
  addAppVersionToDocument(document);
  return document;
};

const removePoolNumberIfBillingTypeIsPriv = (document) => {
  if (document.billingType === BillingType.PRIV) {
    delete document.poolNumber;
  }
};

const addAppVersionToDocument = (document) => {
  document.appVersion = getBuildNumber();
};

export default optimizeDocumentBeforeSave;
